"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../../model/types/EventType");
var Id_1 = require("../../model/types/Id");
var AbstractEvent_1 = require("./AbstractEvent");
var ConversationCreatedEvent = (function (_super) {
    __extends(ConversationCreatedEvent, _super);
    function ConversationCreatedEvent(conversationId) {
        var _this = _super.call(this) || this;
        _this.props = new ConversationCreatedEventProperties(new Id_1.Id(conversationId));
        return _this;
    }
    ConversationCreatedEvent.prototype.getType = function () {
        return EventType_1.EventType.ConversationCreated;
    };
    return ConversationCreatedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.ConversationCreatedEvent = ConversationCreatedEvent;
var ConversationCreatedEventProperties = (function () {
    function ConversationCreatedEventProperties(conversation_id) {
        this.conversation_id = conversation_id;
    }
    return ConversationCreatedEventProperties;
}());
//# sourceMappingURL=ConversationCreatedEvent.js.map